export default "__VITE_ASSET__1070009a__"